import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const goldFDPreOrderApi = createAsyncThunk(
  "goldFDPreOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/fd/preOrderCalculate",
        payload
      );
      console.log("NAG---------------------", response);
      return response.data;
    } catch (error) {
      console.log("NAG---------------------", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const goldFDPreOrderSlice = createSlice({
  name: "goldFDPreOrder",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(goldFDPreOrderApi.pending, (state) => {
        state.status = "loading";
        state.errors = [];
      })
      .addCase(goldFDPreOrderApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(goldFDPreOrderApi.rejected, (state, action) => {
        state.errors.push(action.payload);
        state.status = "idle";
      });
  },
});

export default goldFDPreOrderSlice.reducer;
